import React, { Fragment, useContext, useEffect, useMemo, useRef } from 'react';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import get from 'lodash/get';
import Icon from '../../../Icon';
import Loader from '../../../common/Loader';
import MediaIndicator from '../MediaIndicator';
import { OTContext } from '../../../../redux/opentok/context';
import { formatName } from '../../../../redux/opentok/helpers/utils';
import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';

import styles from './styles.styl';

function MemberView({
  onClick,
  children,
  showControls,
  intl: { formatMessage },
  connection: { ready, id, video, user, stream },
}) {
  const { state, focusedId, PUBLISHER_KEY } = useContext(OTContext);
  const { pinnedId, videoWarningIds } = state;
  const isMe = id === PUBLISHER_KEY;
  const videoRef = useRef();

  const videoType = get(stream, 'videoType');

  const videoReady = useMemo(() => ready && video, [ready, video]);
  const hasSlowConnection = useMemo(() => videoWarningIds.includes(id), [
    videoWarningIds,
    id,
  ]);
  const name = useMemo(() => formatName(user, isMe, formatMessage, videoType), [
    user,
    isMe,
    videoType,
  ]);

  const pinned = id === pinnedId;
  const noVideo = stream && !stream.hasVideo;
  const noAudio = stream && !stream.hasAudio;

  useEffect(() => {
    if (videoReady && videoRef.current) {
      videoRef.current.appendChild(video);
    }
  }, [videoReady]);

  const handleSelect = () => onClick({ stream, id });

  return (
    <div
      onClick={handleSelect}
      className={cn(styles.root, {
        [styles.active]: focusedId === id,
        [styles.me]: isMe,
      })}
    >
      {!videoReady && <Loader className={styles.loader} />}
      {children}
      <Fragment>
        {pinned && (
          <div className={styles.pinned}>
            <div className={styles.pinnedBtn}>
              <Icon name="unpin" size={24} />
            </div>
          </div>
        )}
        <div
          className={cn(styles.video, { [styles.noVideo]: noVideo })}
          ref={videoRef}
        />
        <div className={styles.info}>
          {hasSlowConnection && (
            <Icon
              title={formatMessage({ id: 'virtualVisit.unstableConnection' })}
              className={styles.slowConnection}
              name="connection-slow"
              size={12}
            />
          )}
          {name}
          {showControls && (
            <MediaIndicator
              className={styles.controls}
              pinned={pinned}
              noVideo={noVideo}
              noAudio={noAudio}
            />
          )}
        </div>
      </Fragment>
    </div>
  );
}

MemberView.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  connection: ConnectionShape,
  showControls: PropTypes.bool,
  intl: PropTypes.object,
};

MemberView.defaultProps = {
  showControls: false,
};

export default injectIntl(MemberView);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MemberView/index.jsx